import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getReports } from '../../../store/report/actions';
//import DatePicker from "react-datepicker";
//import "react-datepicker/dist/react-datepicker.css";
import CustomDatePicker from '../../../components/CustomDatePicker/CustomDatePicker'
import { createBrowserHistory } from 'history';
function Reports() {
    const history = createBrowserHistory();
    const dispatch = useDispatch();


    const { reportList } = useSelector(state => state.reportlists);
    const [filter, setFilter] = useState({ reportType: 'All', locationStatus: 0, startDate: new Date(), endDate: new Date(), endDateError: null, startDateUtc: new Date(), endDateUtc: new Date() });
    useEffect(() => {

        let filterType = location.pathname;
        const segment = filterType.split('/');
        const value = segment.length > 1 ? segment.pop() : '';
        if (value != "report") {
            const selectedReportType = reportType.find(type => type.id === (value == "" || value == "report" ? 'type' : value));
            selectedReportType && handleFilterReport(value == "" || value == "report" ? 'type' : value, false);
        }

        const unlisten = history.listen((location) => {
            let pn = location.location.pathname;
            const segments = pn.split('/');
            const value = segments.length > 1 ? segments.pop() : ''; // Check if there are segments before popping
            //setFilter((prevFilter) => ({
            //    ...prevFilter,
            //    reportType: value,
            //}));
            const selectedReportType = reportType.find(type => type.id === (value == "" || value == "report" ? 'type' : value) );
            selectedReportType && handleFilterReport(value == "" || value == "report" ? 'type' : value, false);
        });

        return () => {

            unlisten();

        };
    }, []);
    useEffect(() => {
        if (filter.reportType !== 'All') {

            const startDateUtc = new Date(Date.UTC(
                filter.startDate.getFullYear(),
                filter.startDate.getMonth(),
                filter.startDate.getDate(),
                filter.startDate.getHours(),
                filter.startDate.getMinutes(),
                filter.startDate.getSeconds()
            ));
            filter.startDateUtc = startDateUtc;

            const endDateUtc = new Date(Date.UTC(
                filter.endDate.getFullYear(),
                filter.endDate.getMonth(),
                filter.endDate.getDate(),
                filter.endDate.getHours(),
                filter.endDate.getMinutes(),
                filter.endDate.getSeconds()
            ));
            filter.endDateUtc = endDateUtc;


            dispatch(getReports(filter));
        }
    }, [filter]);

    const reportType = [
        { id: 'type', name: "Select Report Period" },
        { id: 'ThisMonth', name: "This Month" },
        { id: 'LastMonth', name: "Last Month" },
        { id: 'YeartoDate', name: "Year to Date" },
        { id: 'Custom', name: "Custom" }
    ];
  

    const handleFilterReport = (e, isSelectedReportType = true) => {     
        const selectedTypeId = isSelectedReportType ? (e.target.value) : e;

        if (isSelectedReportType) {
            const newUrl = `/report/${selectedTypeId}`;
            if (history.location.pathname !== newUrl) {
                history.push(newUrl);              
            } 

        } 
        const selectedReportType = reportType.find(type => type.id === selectedTypeId);

        let startDate = filter.startDate;
        let endDate = filter.endDate;

        if (selectedReportType.name === 'This Month') {
            const today = new Date();
            startDate = new Date(today.getFullYear(), today.getMonth(), 1);
            endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        } else if (selectedReportType.name === 'Last Month') {
            const today = new Date();
            const lastMonthStartDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            const lastMonthEndDate = new Date(today.getFullYear(), today.getMonth(), 0);
            startDate = lastMonthStartDate;
            endDate = lastMonthEndDate;
        } else if (selectedReportType.name === 'Year to Date') {
            const today = new Date();
            startDate = new Date(today.getFullYear(), 0, 1);
            endDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        } else if (selectedReportType.name === 'Custom') {
            // Assuming filter.startDate and filter.endDate are already in UTC
            startDate = filter.startDate;
            endDate = filter.endDate;
        } else {
            startDate = new Date();
            endDate = new Date();
        }

        setFilter({
            ...filter,
            reportType: selectedReportType.id,
            startDate: startDate,
            endDate: endDate
        });
    };


    const handleStartDateChange = (date) => {
        setFilter({ ...filter, startDate: date, reportType: 'Custom' });
        const newUrl = '/report/Custom';
        if (history.location.pathname !== newUrl) {
            history.push(newUrl);
        }   
        //if (date <= filter.endDate) {
        //    setFilter({ ...filter, startDate: date, reportType: 'Custom', startDateError: null });
        //} else {
        //    setFilter({ ...filter, startDate: date, reportType: 'Custom', startDateError: "Start date cannot be later than end date" });
        //}
    };

    const handleEndDateChange = (date) => {
        setFilter({ ...filter, endDate: date, reportType: 'Custom' }); 
        const newUrl = '/report/Custom';
        if (history.location.pathname !== newUrl) {
            history.push(newUrl);
        } 
        //if (date >= filter.startDate) {
        //    setFilter({ ...filter, endDate: date, reportType: 'Custom', endDateError: null });
        //} else {
        //    setFilter({ ...filter, endDate: date, reportType: 'Custom', endDateError: "End date cannot be earlier than start date" });
        //}
    };
    useEffect(() => {
    }, [filter]);


    const handleStartPrevDay = () => {
        const prevDay = new Date(filter.startDate);
        prevDay.setDate(prevDay.getDate() - 1);
        setFilter({ ...filter, startDate: prevDay, reportType: 'Custom' });
        const newUrl = '/report/Custom';
        if (history.location.pathname !== newUrl) {
            history.push(newUrl);
        } 

    };

    const handleStartNextDay = () => {
        const nextDay = new Date(filter.startDate);
        nextDay.setDate(nextDay.getDate() + 1);
        setFilter({ ...filter, startDate: nextDay, reportType: 'Custom' });
        const newUrl = '/report/Custom';
        if (history.location.pathname !== newUrl) {
            history.push(newUrl);
        }   
    };

    const handleEndPrevDay = () => {
        const prevDay = new Date(filter.endDate);
        prevDay.setDate(prevDay.getDate() - 1);
        setFilter({ ...filter, endDate: prevDay, reportType: 'Custom' });
        const newUrl = '/report/Custom';
        if (history.location.pathname !== newUrl) {
            history.push(newUrl);
        } 
    };

    const handleEndNextDay = () => {
        const nextDay = new Date(filter.endDate);
        nextDay.setDate(nextDay.getDate() + 1);
        setFilter({ ...filter, endDate: nextDay, reportType: 'Custom' });
        const newUrl = '/report/Custom';
        if (history.location.pathname !== newUrl) {
            history.push(newUrl);
        } 
    };

    return (
        <>
            <div className="admin-page-wrap report-page-wrapper">
                <div className="pageContainer page-container-scroll">
                    <div className="admin-page-content w-100">
                        <div className="admin-page-title-wrap">
                            <h1 className="admin-page-heading">Reports</h1>
                            <div className="admin-bottom-bar filter-bar">
                                <div className="admin-bottom-bar-left align-end">
                                    <select className="admin-default-select quoteradius select-report" value={filter.reportType} onChange={handleFilterReport}>
                                        {reportType.map((option, index) => (
                                            <option key={index} value={option.id} disabled={option.disabled}>
                                                {option.name}
                                            </option>
                                        ))}
                                    </select>
                                    {(
                                        <>
                                            <div className="report-date-wrapper">
                                                {/*<label className="admin-default-label">Start Date</label>*/}
                                                {/*<DatePicker*/}
                                                {/*    className="admin-default-input-text"*/}
                                                {/*    selected={filter.startDate}*/}
                                                {/*    placeholder="mm/dd/yyyy"*/}
                                                {/*    autoComplete="off"*/}
                                                {/*    onChange={handleStartDateChange}*/}
                                                {/*/>*/}
                                               {/* varient="BtnFalse"*/}
                                                <CustomDatePicker
                                                    varient=""
                                                    className={`admin-default-input-text bold-dete-picker ${filter.startDateError ? 'error' : ''}`}
                                                    selected={filter.startDate}
                                                    placeholder="mm/dd/yyyy"
                                                    autoComplete="off"
                                                    onChange={handleStartDateChange}
                                                    handlePrevDay={handleStartPrevDay}
                                                    handleNextDay={handleStartNextDay}
                                                />
                                                {filter.startDateError && <p className="error-message">{filter.startDateError}</p>}
                                            </div>
                                            <div className="date-to">
                                                to
                                            </div>

                                            <div className="report-date-wrapper">
                                                {/*<label className="admin-default-label">End Date</label>*/}
                                                {/*<DatePicker*/}
                                                {/*    className="admin-default-input-text"*/}
                                                {/*    selected={filter.endDate}*/}
                                                {/*    placeholder="mm/dd/yyyy"*/}
                                                {/*    autoComplete="off"*/}
                                                {/*    onChange={handleEndDateChange}*/}
                                                {/*/>*/}
                                                <CustomDatePicker
                                                    varient=""
                                                    className={`admin-default-input-text bold-dete-picker ${filter.endDateError ? 'error' : ''}`}
                                                    selected={filter.endDate}
                                                    placeholder="mm/dd/yyyy"
                                                    autoComplete="off"
                                                    onChange={handleEndDateChange}
                                                    handlePrevDay={handleEndPrevDay}
                                                    handleNextDay={handleEndNextDay}
                                                />
                                                {filter.endDateError && <p className="error-message">{filter.endDateError}</p>}
                                            </div>
                                        </>
                                    )}

                                </div>
                            </div>
                        </div>
                        <div className="pt">
                            <table className="admin-table w-100">
                                <tbody>
                                    <tr>
                                        <th className="admin-table-name-cell">Location</th>
                                        <th className="admin-table-name-cell text-right">Sent</th>
                                        <th className="admin-table-name-cell text-right">Confirmed</th>
                                        <th className="admin-table-name-cell text-right">Cancelled</th>
                                        <th className="admin-table-name-cell text-right">Rescheduled</th>
                                        <th className="admin-table-name-cell text-right">Other</th>
                                        <th className="admin-table-name-cell text-right">No Response</th>
                                        <th className="admin-table-name-cell text-right">Failure</th>
                                        <th className="admin-table-name-cell text-right">Opt Out</th>
                                    </tr>

                                    {reportList && reportList.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.locationName}</td>
                                            <td className="text-right">{item.totalSent}</td>
                                            <td className="text-right">{item.confirmed}</td>
                                            <td className="text-right">{item.cancelled}</td>
                                            <td className="text-right">{item.rescheduled}</td>
                                            <td className="text-right">{item.paused}</td>
                                            <td className="text-right">{item.noResponse}</td>
                                            <td className="text-right">{item.failure}</td>
                                            <td className="text-right">{item.optOut}</td>
                                        </tr>
                                    ))}

                                    {(reportList && reportList.length > 0) ?
                                        <tr>
                                            <td className="reportcolumbold">Total</td>
                                            <td className="reportcolumbold text-right">{reportList && reportList.reduce((sum, item) => sum + item.totalSent, 0)}</td>
                                            <td className="reportcolumbold text-right">{reportList && reportList.reduce((sum, item) => sum + item.confirmed, 0)}</td>
                                            <td className="reportcolumbold text-right">{reportList && reportList.reduce((sum, item) => sum + item.cancelled, 0)}</td>
                                            <td className="reportcolumbold text-right">{reportList && reportList.reduce((sum, item) => sum + item.rescheduled, 0)}</td>
                                            <td className="reportcolumbold text-right">{reportList && reportList.reduce((sum, item) => sum + item.paused, 0)}</td>
                                            <td className="reportcolumbold text-right">{reportList && reportList.reduce((sum, item) => sum + item.noResponse, 0)}</td>
                                            <td className="reportcolumbold text-right">{reportList && reportList.reduce((sum, item) => sum + item.failure, 0)}</td>
                                            <td className="reportcolumbold text-right">{reportList && reportList.reduce((sum, item) => sum + item.optOut, 0)}</td>
                                        </tr>
                                        : <tr></tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Reports;